const ViewActionTypes = {
  SET_CURRENT_VIEW: 'SET_CURRENT_VIEW',
};

export default ViewActionTypes;